import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=061dc11a&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('061dc11a')) {
      api.createRecord('061dc11a', component.options)
    } else {
      api.reload('061dc11a', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=061dc11a&", function () {
      api.rerender('061dc11a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2qyUXokG8BiYN/JS/imageCarousel.vue"
export default component.exports